import React, {useCallback} from "react";
import {Grid, Card, CardActionArea, CardContent, Typography, Divider} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {NavigateNext} from "@mui/icons-material";
import {ShortAutoVisit} from "~/apps/packages/auto-visits/queries";
import {AutoVisitStatusBadge} from "~/apps/packages/auto-visits/components/AutoVisitStatusBadge";
import moment from "moment";
import {VehicleNumber} from "~/apps/core/ui/VehicleNumber";
import {PortTheme} from "~/ui/theme";
import {LockClose} from "~/ui/icons";
import {TypographyWithIcon} from "~/apps/core/ui/TypographyWithIcon";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import {formatDate} from "~/apps/core/utils";


export type AutoVisitItemProps = {
    autoVisit: ShortAutoVisit
    onClick?: () => void
}


const useStyles = makeStyles<PortTheme>(theme => ({
    root: {
        width: "100%",
    },
}));


export const AutoVisitItem = (props: AutoVisitItemProps) => {
    const {autoVisit, onClick} = props;
    const classes = useStyles(props);

    const handleClick = () => {
        onClick && onClick();
    }

    return (
        <Card className={classes.root}>
            <CardActionArea onClick={handleClick}>
                <CardContent>
                    <Grid container direction="column" rowSpacing="8px" wrap="nowrap">
                        <Grid item container direction="column" wrap="nowrap" rowSpacing="4px">
                            <Grid item container direction="row" justifyContent="space-between">
                                <Grid item>
                                    <AutoVisitStatusBadge>
                                        {autoVisit.status}
                                    </AutoVisitStatusBadge>
                                </Grid>
                                <Grid item>
                                    <Typography variant="cardText">
                                        {formatDate(moment(autoVisit.date, "YYYY-MM-DD"))}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item container direction="row" justifyContent="space-between">
                                <Grid item>
                                    <VehicleNumber number={autoVisit.vehicleId}/>
                                </Grid>

                                {autoVisit.pin && (
                                    <Grid item>
                                        <TypographyWithIcon variant="cardText" color="additionalPrimary.main"
                                                            startIcon={<LockClose style={{width: 16, height: 16}}/>}>
                                            PIN {autoVisit.pin || <>&ndash;&ndash;&ndash;&ndash;</>}
                                        </TypographyWithIcon>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Divider/>
                        </Grid>
                        <Grid item>
                            <TypographyWithLabel label="Водитель">
                                {autoVisit.driverName}
                            </TypographyWithLabel>
                        </Grid>
                        <Grid item>
                            <TypographyWithLabel label="Название груза">
                                {autoVisit.cargoInfo || <>&ndash;</>}
                            </TypographyWithLabel>
                        </Grid>
                        <Grid item container direction="row" justifyContent="space-between" alignItems="flex-end">
                            <Grid item>
                                <TypographyWithLabel label="Слот / КПП">
                                    {autoVisit.timeSlotId.split("-")[0].trim()}&ndash;{autoVisit.timeSlotId.split("-")[1].trim()}
                                    &nbsp;
                                    /
                                    &nbsp;
                                    {autoVisit.checkPointName.replace(/\(([^\)]+)\)/, '').trim()}
                                </TypographyWithLabel>
                            </Grid>
                            <Grid item>
                                <TypographyWithIcon endIcon={<NavigateNext/>} color="textSecondary" variant="cardText" marginRight="-8px" marginBottom="-2px">
                                    Подробнее
                                </TypographyWithIcon>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}